import styles from "./World.module.css";

export function World({ worldData, onSelectWorld, isActive }) {
  return (
    <button
      className={`${styles.worldCard}${isActive ? ` ${styles.isActive}` : ""}`}
      onClick={() => {
        onSelectWorld(worldData.id);
      }}
      type="button"
    >
      <span className={styles.worldTitle}>{worldData.worldName}</span>
      <span className={styles.worldMeta}>
        {worldData.stippets.length} stippet
        {worldData.stippets.length === 1 ? "" : "s"}
      </span>
    </button>
  );
}
